export const pick = (obj, keysOrMap) => {
    const mapEntries = Array.isArray(keysOrMap)
        ? keysOrMap.map((key) => [key, key])
        : Object.entries(keysOrMap);
    return Object.fromEntries(mapEntries.map(([key, value]) => [key, obj[value]]));
};
